import {Base64} from "js-base64";

export default {
    config : {
        cookieName: "ctx_sf_pf",
        dataStoreName: "ctx_sf_data",
        expiration: 90
    },
    set(data){
        let dataObj = JSON.stringify({"data": Base64.encode(JSON.stringify(data))})
        this.setCookie(this.config.cookieName, true, this.config.expiration)
        this.setStorageData(dataObj)
    },
    get(){
        let cookieCheck = this.getCookie(this.config.cookieName)
        if(cookieCheck){
            let storeData = this.getStorageData()
            if(storeData){
                return JSON.parse(Base64.decode(JSON.parse(storeData).data))
            }
            this.unset()
        }
        this.unset()
    },
    unset(){
        this.setCookie(this.config.cookieName, true, "Thu, 01 Jan 1970 00:00:00 UTC")
        localStorage.removeItem(this.config.dataStoreName)
    },
    getStorageData(){
        return localStorage.getItem(this.config.dataStoreName)
    },
    setStorageData(dataObj){
        localStorage.setItem(this.config.dataStoreName, dataObj)
    },
    getCookie(name) {
        name += "="
        let decodedCookie = decodeURIComponent(document.cookie)
        let ca = decodedCookie.split(';')
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ""
    },
    setCookie(name, value, days) {
        var date, expires;
        if (days) {
            date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            expires = "; expires="+date.toUTCString();
        } else {
            expires = "";
        }
        document.cookie = name+"="+value+expires+"; path=/";
    }
}